export default {
    paddingSingle: '0 26px 0 14px',
    clearSize: '16px',
    arrowSize: '16px'
};
